import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgxCookieConsentModule } from '@localia/ngx-cookie-consent';
import { NbThemeModule } from '@nebular/theme';
import { AbService, AnalyticsService, CurrentThemeService, FCMStore, SeoService } from '@res/ngg-core';
import {
  CellStyleModule,
  ColumnApiModule,
  DateEditorModule,
  DateFilterModule,
  ExternalFilterModule,
  InfiniteRowModelModule,
  LocaleModule,
  ModuleRegistry,
  NumberEditorModule,
  NumberFilterModule,
  PaginationModule,
  RenderApiModule,
  RowApiModule,
  RowStyleModule,
  SelectEditorModule,
  TextEditorModule,
  TooltipModule,
} from 'ag-grid-community';
import {
  LicenseManager,
  ServerSideRowModelApiModule,
  ServerSideRowModelModule,
  ValidationModule,
} from 'ag-grid-enterprise';

@Component({
  standalone: true,
  imports: [CommonModule, RouterModule, NgxCookieConsentModule, NbThemeModule],
  providers: [AnalyticsService, SeoService, AbService, CurrentThemeService],
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'clc-app',
  template: `
    <ngx-cookie-consent />
    <router-outlet />
  `,
})
export class AppComponent implements OnInit {
  private readonly fcmStore = inject(FCMStore);
  private readonly analytics = inject(AnalyticsService);
  private readonly seoService = inject(SeoService);
  private readonly currentThemeService = inject(CurrentThemeService);
  // private readonly cookieConsentService = inject(NgxCookieConsentService);
  // private readonly remoteConfigService = inject(RemoteConfigService);
  // private readonly cookieManagerService = inject(NgxCookieManagerService);

  ngOnInit(): void {
    this.fcmStore.initFCMs();

    // const remoteCookieConsetConfig = this.remoteConfigService.getConfigValue(RemoteConfigKey.cookieConsentConfig);
    // Object.entries(remoteCookieConsetConfig).forEach(([key, value]) => {
    //   this.cookieConsentService.setConfig(key, value);
    // });
    // this.CookieManagerService.
    // Register all Community features
    ModuleRegistry.registerModules([
      ServerSideRowModelModule,
      ServerSideRowModelApiModule,
      InfiniteRowModelModule,
      DateFilterModule,
      NumberEditorModule,
      ExternalFilterModule,
      DateEditorModule,
      NumberFilterModule,
      TextEditorModule,
      SelectEditorModule,
      CellStyleModule,
      RowStyleModule,
      RowApiModule,
      PaginationModule,
      TooltipModule,
      ValidationModule,
      RenderApiModule,
      ColumnApiModule,
      LocaleModule,
    ]);
    LicenseManager.setLicenseKey('KingPeti_[v3]_[BOTH]_[0102]_MzI1MDM2NzY0MDAwMDA=46361dbade439c231ab4f1c27b2b0b64');

    // const variants = [
    //   AbService.VARIANT_THEME_CORPORATE,
    //   AbService.VARIANT_THEME_DEFAULT,
    //   AbService.VARIANT_THEME_COSMIC,
    //   AbService.VARIANT_THEME_DARK,
    // ];
    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();
    this.currentThemeService.initialize();
    // this.abService
    //   .onAbEvent()
    //   .pipe(
    //     withLatestFrom(this.activatedRoute.queryParams),
    //     filter(([, params]: [{ name: string }, Params]) => !params['theme'])
    //   )
    //   .subscribe(([e]: [{ name: string }, Params]) => {
    //     const themeName = e.name.replace('theme-change-', '');
    //     if (variants.includes(e.name) && this.themes.includes(themeName)) {
    //       this.themeService.changeTheme(themeName);
    //     }
    //   });
  }
}
